{
  "method": {
    "bankTransfer": "Bank transfer",
    "cash": "Cash"
  },
  "home": {
    "remaining": "Your balance",
    "agreement": "Your agreement: {{label}}",
    "noAgreement": "No active agreement",
    "agreementFile": "Agreement file",
    "upcoming": "New agreement starts on {{date}}",
    "upcomingFile": "Upcoming agreement file",
    "earned": "Earned",
    "transferred": "Transferred",
    "pending": "Pending",
    "pendingHint": "Pending: commission on bookings the customer hasn't paid yet; it becomes earned once paid.",
    "lastPayout": "Last transfer:",
    "tapForReceipt": "Tap to view the receipt",
    "recent": "My latest bookings",
    "all": "All",
    "noBookings": "No bookings yet",
    "hello": "Hello {{name}}",
    "whatsapp": "Your assigned agency WhatsApp",
    "whatsappHint": "for customer conversations"
  },
  "bookings": {
    "title": "My commissions",
    "month": "Month",
    "filterLabel": "Filter by commission status",
    "all": "All",
    "total": "{{n}} bookings",
    "shareTotal": "Your share total:",
    "empty": "No matching bookings"
  },
  "payouts": {
    "title": "Transfers and receipts",
    "transferredTotal": "Total transferred",
    "remaining": "Your balance",
    "covers": "Covers {{n}} bookings",
    "voided": "Voided",
    "viewReceipt": "View receipt",
    "empty": "No transfers yet",
    "hint": "Transfers appear here as soon as the administration records them, together with the transfer receipt."
  },
  "receipt": {
    "back": "Back",
    "title": "Transfer {{date}}",
    "alt": "Transfer receipt {{name}}",
    "download": "Download receipt",
    "entries": "Included bookings",
    "crumb": "Receipt"
  },
  "notifications": {
    "title": "Notifications",
    "emptyTitle": "No notifications",
    "emptyDescription": "Any changes to your agreement will appear here.",
    "cancelled": {
      "title": "Scheduled agreement cancelled",
      "body": "The agreement ({{terms}} of each booking fee) that was due to start on {{day}} was cancelled. Your current agreement continues."
    },
    "changed": {
      "title": "Your agreement was updated",
      "body": "Your agreement is now {{terms}} of each booking fee, effective {{day}}."
    },
    "scheduled": {
      "title": "New agreement scheduled",
      "titleUpdated": "Scheduled agreement changed",
      "body": "Your next agreement: {{terms}} of each booking fee, starting {{day}}."
    }
  },
  "my": {
    "title": "My bookings",
    "earnings": "My commissions",
    "new": "New booking",
    "search": "Search my bookings",
    "searchPlaceholder": "Reference, customer, phone",
    "filterLabel": "Filter by booking status",
    "all": "All",
    "share": "Your share:",
    "empty": "No bookings yet",
    "count": "{{n}} bookings",
    "columns": {
      "reference": "Booking no.",
      "customer": "Customer",
      "partner": "Partner",
      "fee": "Fee",
      "share": "Your share",
      "status": "Status",
      "date": "Date"
    }
  },
  "form": {
    "back": "Back",
    "newTitle": "New booking",
    "editTitle": "Edit {{ref}}",
    "parties": "Booking parties",
    "customer": "Customer",
    "customerPlaceholder": "Search by name or phone",
    "customerSearch": "Customer name or phone",
    "noCustomers": "No matching customers",
    "newCustomer": "New customer",
    "partner": "Partner",
    "partnerPlaceholder": "Choose a partner",
    "partnerSearch": "Partner name",
    "noPartners": "No active partners",
    "confirmation": "Partner confirmation number",
    "optional": "Optional",
    "amounts": "Amounts & invoice",
    "bookingAmount": "Booking amount ({{currency}})",
    "fee": "Service fee ({{currency}})",
    "yourShare": "Your agreement: {{label}}",
    "billingMode": "Invoice mode",
    "summary": "Summary",
    "myShare": "Your share",
    "invoiceTotal": "Total for the customer",
    "confirm": "Confirm booking",
    "saveDraft": "Save as draft",
    "saveChanges": "Save changes",
    "saving": "Saving…",
    "saved": "Changes saved",
    "confirmed": "Booking confirmed",
    "draftSaved": "Draft saved",
    "failed": "Couldn't save",
    "pickCustomer": "Choose the customer",
    "pickPartner": "Choose the partner",
    "feePositive": "The fee must be greater than zero"
  },
  "detail": {
    "confirm": "Confirm booking",
    "issueInvoice": "Issue invoice",
    "copyLink": "Copy payment link",
    "retry": "Retry sending",
    "edit": "Edit",
    "details": "Booking details",
    "phone": "Phone",
    "bookingAmount": "Booking amount",
    "fee": "Service fee",
    "full": "Full invoice",
    "feeOnly": "Service fee only",
    "timeline": "Activity",
    "invoice": "Invoice",
    "total": "Total",
    "due": "Due",
    "noInvoice": "No invoice yet. Confirm the booking, then issue the invoice to send the customer a payment link.",
    "linkCopied": "Payment link copied",
    "done": {
      "confirm": "Booking confirmed",
      "invoice": "Invoice issued, sending to StreamPay",
      "retry": "Sending retried"
    }
  },
  "agreements": {
    "title": "My agreement",
    "hint": "Your current, upcoming and past agreements, each with its file.",
    "empty": "No agreements",
    "range": "From {{from}} to {{to}}",
    "openRange": "From {{from}} — open-ended",
    "view": "View",
    "download": "Download agreement",
    "noFile": "No file attached to this agreement"
  },
  "customers": {
    "title": "Customers",
    "subtitle": "{{n}} customers",
    "searchLabel": "Search customers",
    "searchPlaceholder": "Name, mobile",
    "new": "New customer",
    "emptyTitle": "No customers",
    "noMatches": "No customers match your search.",
    "addFirst": "Register the first customer to get started.",
    "columns": {
      "name": "Customer",
      "phone": "Mobile",
      "email": "Email"
    },
    "myBookings": "My bookings with them",
    "added": "Registered",
    "newBooking": "New booking for this customer",
    "edit": "Edit",
    "myBookingsTitle": "My bookings for this customer",
    "noBookings": "No bookings"
  }
}
